import { Component } from 'react';

import {
  createInstructionMarkup,
  createMoreInstructionMarkup,
  questionComponentPropTypes,
} from './helpers';
import Immutable from 'immutable';
import MarkingResponse from './MarkingResponse';
import { Button } from 'react-bootstrap';

class SampleMarkQuestion extends Component {
  handleResponseChange = (e) => {
    this.props.onResponseChange(
      this.props.response.set('answer', e.target.value)
    );
  };

  disabled = () => {
    return !this.props.response.get('answer') || this.props.isSaving;
  };

  handleKeyUp = (e) => {
    if (e.key === 'Enter' && !this.disabled()) {
      this.props.onSaveClick();
    }
  };

  render = () => {
    return (
      <div className="question integer-question">
        <div className="left">
          <span>
            <MarkingResponse
              response={this.props.response}
              label={this.props.question.get('marking_prompt')}
              marksAvailable={this.props.question.get(
                'indicated_maximum_marks'
              )}
              onChange={this.handleResponseChange}
              onKeyUp={this.handleKeyUp}
            />
            <Button onClick={this.props.onSaveClick} disabled={this.disabled()}>
              Save &amp; Continue
            </Button>
          </span>
          <span
            className="response-text"
            dangerouslySetInnerHTML={createInstructionMarkup(
              this.props.question
            )}
          />
        </div>
        <div className="right">
          <span
            className="rubric"
            dangerouslySetInnerHTML={createMoreInstructionMarkup(
              this.props.question
            )}
          />
        </div>
      </div>
    );
  };
}

SampleMarkQuestion.propTypes = questionComponentPropTypes;
SampleMarkQuestion.defaultProps = {
  response: Immutable.Map(),
};

export default SampleMarkQuestion;
